<script setup lang="ts">

import {TooltipContent, TooltipProvider, TooltipRoot, TooltipTrigger} from "reka-ui";

interface Props {
    content?: string
    classTrigger?: string
}

defineProps<Props>()

</script>

<template>
    <TooltipRoot>
        <TooltipTrigger :class="classTrigger">
                <slot/>
        </TooltipTrigger>
        <TooltipContent v-bind="{...$attrs }"
                        :alignOffset="10"
                        class="
                            z-50 overflow-hidden rounded-md px-3 py-1.5 text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2
                            border bg-secondary-50 border-secondary-200 dark:bg-secondary-800 dark:border-secondary-600 dark:text-white
                        "
        >
            <slot name="content">{{ content }}</slot>
        </TooltipContent>
    </TooltipRoot>
</template>
